import { ItemType } from "../../../types/data.types";
import { ICard, DCResearchCards } from "../../../types/cards.types";

export const REPORT_NAME = "Current Inventory Health Summary";

export const CARDS: ICard<DCResearchCards>[] = [
  {
    key: "dcEstimatedArrivalDate",
    type: "date",
    label: "DC Estimated",
    label2: "Arrival Date",
  },
  {
    key: "dcLastDateReceived",
    type: "date",
    label: "DC Last Date",
    label2: "Received",
  },
  {
    key: "thisWeeksDemand",
    type: "number",
    label: "This Weeks",
    label2: "Demand",
  },
  {
    key: "mgrOptionR",
    label: "Mgr.Option",
    label2: "R",
  },
  {
    key: "cosmoLimits",
    label: "Cosmos",
    label2: "Limits",
  },
  {
    key: "codeDatePickSlot",
    label: "Code Date In",
    label2: "Pick Slot",
  },
];

export const getItemType = (itemType: ItemType) => {
  const isFar = itemType.type === "WAREHOUSE" && itemType.subType === "FAR";
  const isNonFar =
    itemType.type === "WAREHOUSE" && itemType.subType === "NON_FAR";
  const isDsd = itemType.type === "DSD" && itemType.subType === "NON_FRESH";

  return {
    isUnified: itemType.type === "UNIFIED",
    isFar,
    isNonFar,
    isDsd,
  };
};
